var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDdWishlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0C12.76 0 11.09 0.8505 10 2.1945C8.91 0.8505 7.24 0 5.5 0C2.42 0 0 2.541 0 5.775C0 9.744 3.4 12.978 8.55 17.892L10 19.2675L11.45 17.8815C16.6 12.978 20 9.744 20 5.775C20 2.541 17.58 0 14.5 0ZM10.1 16.3275L10 16.4325L9.9 16.3275C5.14 11.802 2 8.8095 2 5.775C2 3.675 3.5 2.1 5.5 2.1C7.04 2.1 8.54 3.1395 9.07 4.578H10.94C11.46 3.1395 12.96 2.1 14.5 2.1C16.5 2.1 18 3.675 18 5.775C18 8.8095 14.86 11.802 10.1 16.3275Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdWishlist);
export default __webpack_public_path__ + "static/media/dd-wishlist.0c2e1044ac30b44d03afc787b88bc3e3.svg";
export { ForwardRef as ReactComponent };